import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialTipoPromotoreState } from './tipo_promotore.state';
import { getTipoPromotore } from './tipo_promotore.utility';
import { GetTipoPromotoreGQL } from '../../_graphql/generated';

export const TipoPromotoreStore = signalStore(
  { providedIn: 'root' },
  withState(initialTipoPromotoreState),
  withProps(() => ({
    getter: inject(GetTipoPromotoreGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTipoPromotore(injector, store, getter),
  }))
);
